import { useMemo } from 'react'

type Device = {
  id: string
  label: string
}

export const useValidDevices = (devices?: Device[], selectedDeviceId?: string) => {
  const validDevices = useMemo(() => devices?.filter((device) => device.id && device.id.trim() !== ''), [devices])

  const selectValue = useMemo(() => {
    const isValidSelection = selectedDeviceId && validDevices?.some((d) => d.id === selectedDeviceId)
    return isValidSelection ? selectedDeviceId : undefined
  }, [selectedDeviceId, validDevices])

  return { validDevices, selectValue }
}
